export const MM_NEWS_MARKET_LIST_URL = 'https://www.moomoo.com/news/main';
export const NN_NEWS_MARKET_LIST_URL = 'https://news.futunn.com/main';
